import DOMPurify from 'dompurify'

export function sanitizeHtml(html, options = {}) {
  if (!html) return ''

  return DOMPurify.sanitize(String(html), options)
}
